/* MAEN 2026-10-22: header dropdowns (WATCHES, ABOUT) stay open while the mouse moves quickly from the top link to the panel.
   The theme closes a dropdown the moment the mouse leaves its top link, and that hover area is only the word itself –
   a quick diagonal move to a link further left or right in the full-width panel left the word sideways and closed it;
   a quick move straight down closed it too (see the "leave" into its own panel below).
   - Leaving an open dropdown's top link at header height: it closes after a short grace time, unless the mouse is on it
     (link or panel) again by then. Leaving through the panel still closes it at once (theme behaviour).
   - Passing over another top item while a dropdown is open: the menu only switches when the mouse stays on that item.
   Mouse only; keyboard, touch and opening the first dropdown work exactly as in the theme. */
(function () {
  if (window.maenMenuHover) return;
  window.maenMenuHover = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 300; // ms the mouse has to reach the panel after leaving the top link
  var SWITCH_DELAY = 150; // ms on another top item before the menu switches to it
  var timer = 0;
  var closeAt = 0; // end of the grace time after leaving the open item

  function topItems() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-header-wrapper] hover-disclosure'));
  }

  function isTopItem(el) {
    return el instanceof Element && el.matches('hover-disclosure') && !!el.closest('[data-header-wrapper]') && typeof el.hideDisclosure === 'function';
  }

  function isOpen(item) {
    return item.classList.contains('is-visible');
  }

  function otherOpen(item) {
    return topItems().some(function (el) { return el !== item && isOpen(el); });
  }

  function stop() {
    clearTimeout(timer);
    timer = 0;
    closeAt = 0;
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(settle, ms);
  }

  // the top item under the mouse (its link or panel) decides which dropdown is open; none = all closed
  function settle() {
    timer = 0;
    var items = topItems();
    var hovered = items.filter(function (item) { return item.matches(':hover'); })[0];
    if (!hovered && closeAt > Date.now()) {
      schedule(closeAt - Date.now()); // still within the grace time
      return;
    }
    closeAt = 0;
    // hide first: the theme's hide also clears the header's "mega menu open" state that the show then sets again
    items.forEach(function (item) {
      if (item !== hovered && isOpen(item)) item.hideDisclosure();
    });
    if (hovered && !isOpen(hovered)) hovered.showDisclosure({ type: 'mouseenter' });
  }

  // capture phase on the document runs before the theme's own listeners on the item
  document.addEventListener('mouseleave', function (event) {
    var item = event.target;
    if (!isTopItem(item)) return;
    if (event.relatedTarget && item.contains(event.relatedTarget)) {
      // Chrome sends a "leave" when the mouse goes from the theme's header-row layer (shown for 0.2 s after opening)
      // into the panel, although both belong to the item – the theme then closed the dropdown on a quick move down
      event.stopPropagation();
      return;
    }
    if (!isOpen(item)) {
      // only passed over it while another dropdown is open: the theme's hide would clear that dropdown's header state
      if (otherOpen(item)) event.stopPropagation();
      return;
    }
    var link = item.querySelector('[data-top-link]');
    if (!link || event.clientY > link.getBoundingClientRect().bottom) {
      stop(); // left through the panel: the theme closes it now
      return;
    }
    event.stopPropagation();
    closeAt = Date.now() + CLOSE_DELAY;
    schedule(CLOSE_DELAY);
  }, true);

  document.addEventListener('mouseenter', function (event) {
    var item = event.target;
    if (!isTopItem(item)) return;
    if (!otherOpen(item)) {
      stop(); // first dropdown, or back on the open one: the theme shows it as usual
      return;
    }
    event.stopPropagation();
    schedule(SWITCH_DELAY);
  }, true);
})();
